// English word pools for Niveau 4 (optional lexicon — see UserPreferences.niveau4Lexicon).

import { NIVEAU_1_UNLOCKED_KEYS } from './niveau-1';
import { NIVEAU_2_UNLOCKED_KEYS } from './niveau-2';
import { NIVEAU_3_UNLOCKED_KEYS } from './niveau-3';
import { filterWords } from './generators';

export const NIVEAU_4_EN_UNLOCKED_KEYS = [
  ...NIVEAU_3_UNLOCKED_KEYS,
  'c',
  'x',
  'z',
  ',',
  '.',
  '-',
];

export const NIVEAU_1_EN_SPRINT_WORDS = filterWords(
  [
    'he', 'she', 'her', 'the', 'red', 'get', 'ten', 'let', 'rest', 'test',
    'ring', 'fire', 'site', 'rate', 'gate', 'late', 'read', 'head', 'hear',
    'near', 'year', 'idea', 'edge', 'ride', 'hide', 'side', 'tile', 'here',
    'there', 'these', 'tree', 'free', 'feel', 'feed', 'deed', 'seed', 'need',
    'reel', 'heel', 'deer', 'seer', 'greet', 'green', 'regret', 'relate',
  ],
  NIVEAU_1_UNLOCKED_KEYS,
);

export const NIVEAU_2_EN_SPRINT_WORDS = filterWords(
  [
    'then', 'when', 'them', 'they', 'very', 'every', 'never', 'over', 'move',
    'love', 'live', 'give', 'have', 'name', 'same', 'game', 'came', 'home',
    'some', 'come', 'bone', 'tone', 'note', 'vote', 'hope', 'rope', 'type',
    'byte', 'myth', 'rhyme', 'style', 'reply', 'apply', 'enjoy', 'money',
    'happy', 'maybe', 'baby', 'body', 'nobody', 'anybody', 'everybody',
  ],
  NIVEAU_2_UNLOCKED_KEYS,
);

export const NIVEAU_3_EN_SPRINT_WORDS = filterWords(
  [
    'you', 'your', 'our', 'out', 'now', 'how', 'who', 'two', 'too', 'top',
    'stop', 'shop', 'drop', 'prop', 'port', 'post', 'pose', 'spot', 'sport',
    'word', 'work', 'world', 'would', 'could', 'should', 'quote', 'quite',
    'quiet', 'queen', 'quick', 'quilt', 'quark', 'power', 'lower', 'tower',
    'flower', 'shower', 'powerful', 'download', 'upload', 'outlook', 'output',
    'input', 'about', 'around', 'above', 'below', 'allow', 'follow', 'window',
    'shadow', 'yellow', 'narrow', 'arrow', 'borrow', 'tomorrow', 'potato',
  ],
  NIVEAU_3_UNLOCKED_KEYS,
);

export const NIVEAU_4_EN_ALPHABET_WORDS = filterWords(
  [
    'cat', 'can', 'car', 'cap', 'cab', 'cod', 'cop', 'cot', 'cow', 'coy',
    'cub', 'cup', 'cur', 'cut', 'ace', 'ice', 'nice', 'once', 'face', 'race',
    'place', 'space', 'trace', 'dance', 'since', 'force', 'price', 'black',
    'check', 'click', 'clock', 'cloud', 'cross', 'crowd', 'crown', 'crack',
    'cream', 'credit', 'circle', 'civic', 'civil', 'cycle', 'crazy', 'candy',
    'camel', 'cast', 'case', 'cause', 'cafe', 'camp', 'canal', 'cargo',
    'catch', 'chain', 'chair', 'chalk', 'charm', 'chart', 'chase', 'cheap',
    'cheer', 'chess', 'chest', 'chief', 'child', 'chill', 'china', 'chip',
    'chord', 'chose', 'claim', 'clamp', 'clash', 'clasp', 'class', 'claw',
    'clay', 'clear', 'clerk', 'cliff', 'climb', 'cling', 'clip', 'clock',
    'clone', 'close', 'cloth', 'cloud', 'clown', 'coach', 'coast', 'cobra',
    'colon', 'color', 'combo', 'comet', 'comic', 'comma', 'condo', 'coral',
    'couch', 'cough', 'could', 'count', 'court', 'cover', 'craft', 'crane',
    'crash', 'crave', 'crawl', 'creak', 'creek', 'creep', 'crest', 'cried',
    'crime', 'crisp', 'croak', 'crock', 'crop', 'crude', 'cruel', 'crush',
    'crust', 'crypt', 'cubic', 'curly', 'curry', 'curse', 'curve', 'cycle',
    'box', 'fix', 'mix', 'max', 'tax', 'fax', 'hex', 'fox', 'six', 'wax',
    'text', 'next', 'exit', 'exam', 'extra', 'exact', 'index', 'relax',
    'pixel', 'oxide', 'boxes', 'fixes', 'mixed', 'context', 'complex',
    'zoo', 'zone', 'zero', 'zebra', 'zinc', 'zip', 'zoom', 'lazy', 'crazy',
    'prize', 'size', 'breeze', 'freeze', 'zeal', 'zest', 'zonal', 'zones',
    'pizza', 'citizen', 'citrus', 'cylinder', 'crystal', 'central', 'cancel',
    'cancer', 'canvas', 'carbon', 'career', 'carpet', 'carrot', 'casino',
    'castle', 'catalog', 'cattle', 'causal', 'cavity', 'cellar', 'cement',
    'center', 'cereal', 'chance', 'change', 'charge', 'cherry', 'choice',
    'choose', 'chrome', 'cinema', 'circle', 'citron', 'client', 'clinic',
    'closet', 'coffee', 'collar', 'column', 'combat', 'commit', 'common',
    'compel', 'convey', 'copper', 'corner', 'cosmic', 'costly', 'cotton',
    'couple', 'course', 'cousin', 'create', 'credit', 'crisis', 'cruise',
    'custom', 'cute', 'cycle', 'cynic',
  ],
  NIVEAU_4_EN_UNLOCKED_KEYS,
);

/** Korte ord med punktum — korrekt afslutning. */
export const NIVEAU_4_PERIOD_WORDS_EN =
  'the. word. stop. home. book. it is good.';

/** Kort liste med komma. */
export const NIVEAU_4_LIST_SENTENCE_EN =
  'zone, zoo, citron and cycle.';

/** Sætning med naturlig tegnsætning (komma, punktum, bindestreg). */
export const NIVEAU_4_PUNCTUATION_SENTENCE_EN =
  'axel, you can mix words. write an extra-text. zone, zoo.';

export const NIVEAU_4_CONSOLIDATION_SENTENCE_EN =
  'i can write words now, and that is good.';

export const NIVEAU_4_FINAL_SENTENCE_EN =
  'ten finger typing is good training for your fingers';
